import { getColorClassesWithDefaults, ICustomColor } from '~/redux/customColors'
import { actionTypes, updateCustomColors } from '~/redux/draftEditor.js'
import { getCustomColors } from '~/redux/settingsReducer.js'
import { Observable } from 'rxjs'

/*
This epic watches for the ACTION_EDITOR_CONTENT redux action.
Then it extract all color classes from the loaded story
If there are some colors in the story that does not exists in the settings,
default color classes will be created
If some default classes has been added, dispatch updateCustomColors() to update
colors with newly added default color items
*/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customColorsEpic = (action$, store): Observable<any> =>
  action$
    .ofType(actionTypes.ACTION_EDITOR_CONTENT)
    .map((action) => {
      const { mainDraftContent } = action.payload
      const contentState = mainDraftContent.get('contentState')
      const customColors: ICustomColor[] = getCustomColors(store.getState())
      const customColorsWithDefaults = getColorClassesWithDefaults(
        contentState,
        customColors
      )

      // Do not emit any actions if we didn't add any default color
      // It mean that story colors match settings colors
      if (customColors.length === customColorsWithDefaults.length) {
        return null
      }
      return updateCustomColors(customColorsWithDefaults)
    })
    .filter((action) => !!action)

export default customColorsEpic
